export default __webpack_public_path__ + "static/media/six-thinking-hats-template.53e2fc8f.pdf";